import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on "How it Works" on the Help page
 * Event: dental_portal:help:how_it_works_clicked
 */
export function fireHelpHowItWorksClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:how_it_works_clicked');
}
